import axios from "axios";

export const getTeacherDashboard = () =>
  axios.get("/api/dashboard/teacher").then((r) => r.data);

export const getTeacherSchedule = (teacherId) =>
  axios.get("/api/schedules", { params: { teacher_id: teacherId } }).then((r) => r.data);

export const getTeacherAssignmentsList = (teacherId) =>
  axios.get("/api/assignments", { params: { teacherId } }).then((r) => r.data);
